import React from "react";
import { Col, Form, Input, Row } from 'antd';
import { TextField } from '@/components/Form';

const AppForm = ({
                     form,
                     formId,
                     detailData,
                     onSubmit
                 }) => {
    const handleSubmit = (values) => {
        onSubmit(JSON.stringify(values));
    }

    return (
        <Form
            id={formId}
            onFinish={handleSubmit}
            form={form}
            layout="vertical"
            initialValues={detailData}
        >
            <Row gutter={16}>
                <Col span={24}>
                    <TextField
                        fieldName="username"
                        label="Username"
                        required
                        placeholder="Please enter SMS account username"
                    />
                </Col>
                <Col span={24}>
                    <Form.Item
                        name="password"
                        label="Password"
                        required
                    >
                        <Input.Password
                            autoComplete="off"
                            placeholder="Please enter SMS account passcode which use for integrate"/>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <TextField
                        fieldName="endpoint"
                        label="Endpoint"
                        required
                        validators={[{type: "url", message: "Please enter endpoint as a url pattern"}]}
                    />
                </Col>
            </Row>
        </Form>
    );
};

export default React.memo(AppForm);